"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreInitiativesTasksGetAsyncSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../api/index.js");
const actions_1 = require("../_idMap/actions.js");
const actions_2 = require("../../sonar-objects/_idMap/actions.js");
exports.coreInitiativesTasksGetAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    httpSagaOptions: {
        successCombinationActionCreators: [
            (request, response) => (0, actions_1.updateInitiativeReferences)([
                {
                    initiativeId: request.initiativeId,
                    tasks: response.map((_a) => {
                        var { initiativeSonarObjects } = _a, rest = __rest(_a, ["initiativeSonarObjects"]);
                        return (Object.assign(Object.assign({}, rest), { sonarObjects: initiativeSonarObjects.map((object) => ({
                                itemId: object.id,
                                sonarObjectId: object.sonarObjectId
                            })) }));
                    })
                }
            ])
        ],
        successDataActionCreators: [
            (response) => (0, actions_2.updateSonarObjectReferences)(response.reduce((previous, current) => [
                ...previous,
                ...current.initiativeSonarObjects.map((taskObject) => ({
                    displayName: taskObject.displayName,
                    isDeleted: taskObject.isVanished,
                    parentDisplayName: taskObject.parentDisplayName,
                    parentSonarObjectId: taskObject.parentSonarObjectId,
                    relatedCounts: taskObject.relatedCounts,
                    sonarObjectId: taskObject.sonarObjectId,
                    sonarObjectType: taskObject.sonarObjectType,
                    statusId: taskObject.sonarObjectStatusId,
                    tags: taskObject.tagIds,
                    versionNumber: taskObject.versionNumber
                }))
            ], []))
        ]
    },
    name: name_1.CoreInitiativesTasksName,
    receive: true,
    request: true,
    requestHandler: _api_1.getInitiativeTasks
});
//# sourceMappingURL=get.js.map